module.exports = __webpack_public_path__ + "static/media/betaLogo.9750011b.png";